/* eslint-disable @typescript-eslint/no-explicit-any */
export function replaceText(text: string, replacements: any): string {
  const replacedText = text.replace(
    new RegExp(Object.keys(replacements).join('|'), 'gi'),
    match => {
      return replacements[match.toLowerCase()] || match;
    },
  );

  return replacedText;
}
